<template>
  <section class="dp-layout">
    <section class="dp-left">
      <DepartmentPane directory-scope="teaching" @tree-node-click="treeNodeClick"></DepartmentPane>
    </section>
    <section class="dp-right">
      <div class="class-portrait-tabs">
        <el-tabs v-model="activeTab" type="border-card" @tab-click="handleTabClick">
          <div style="margin-bottom: 10px; color: var(--btn-primary, #2563eb); font-weight: bold;">
            <span>所属机构：</span>
            <span>{{ currentDepartmentName || '未选择' }}</span>
          </div>
          <!-- 班级活动/环境/园地 -->
          <el-tab-pane label="班级活动/环境/园地" name="activity">
            <toolbar :buttonList="buttonList" @callFunction="callFunction" :searchList="searchList"></toolbar>
            <div class="table-wrapper">
              <el-table height="100%" :data="tableData" v-loading="listLoading" class="portrait-table portrait-table--activity"
                style="width: 100%" :header-cell-style="{ background: '#f5f7fa', color: '#606266' }">
                <el-table-column label="分类" width="88" align="center">
                  <template slot-scope="scope">
                    <div class="category-cell">
                      <span class="category-name">{{ scope.row.Category }}</span>
                      <el-tag v-if="isPortraitActivityCategory(scope.row.Category) && scope.row.IsVideo === 1"
                        type="warning" size="mini" effect="plain">视频</el-tag>
                      <el-tag v-else-if="isPortraitActivityCategory(scope.row.Category)" type="info" size="mini"
                        effect="plain">图文</el-tag>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column prop="Theme" label="主题" min-width="140" align="left" show-overflow-tooltip>
                  <template slot-scope="scope">
                    <span class="theme-text">{{ scope.row.Theme }}</span>
                    <el-tooltip v-if="scope.row.IsExternalLink === 1 && scope.row.ExternalLink"
                      :content="scope.row.ExternalLink" placement="top" :open-delay="300">
                      <el-tag size="mini" type="success" effect="plain" class="theme-link-tag">外链</el-tag>
                    </el-tooltip>
                  </template>
                </el-table-column>
                <el-table-column label="预览" width="108" align="center">
                  <template slot-scope="scope">
                    <div v-if="getActivityMediaPreview(scope.row)" class="media-thumb"
                      @click="onActivityMediaClick(scope.row)">
                      <img :src="getActivityMediaPreview(scope.row)" class="media-thumb-img" alt="" />
                      <span v-if="isActivityVideoRow(scope.row)" class="media-thumb-play">
                        <i class="el-icon-video-play"></i>
                      </span>
                      <span v-else-if="getActivityImagesCount(scope.row) > 1" class="media-thumb-count">
                        +{{ getActivityImagesCount(scope.row) - 1 }}
                      </span>
                    </div>
                    <span v-else class="cell-placeholder">—</span>
                  </template>
                </el-table-column>
                <el-table-column label="涉及学生" min-width="160" align="center">
                  <template slot-scope="scope">
                    <div
                      v-if="getActivityStudentNames(scope.row).length"
                      class="member-cell member-cell--text"
                      @click="openActivityStudentDialog(scope.row)"
                    >
                      <span class="member-cell__text-preview">{{ formatActivityStudentsPreview(scope.row) }}</span>
                      <span class="member-cell__more">共 {{ getActivityStudentNames(scope.row).length }} 人</span>
                    </div>
                    <span v-else class="cell-placeholder">—</span>
                  </template>
                </el-table-column>
                <el-table-column label="创建" width="168" align="center">
                  <template slot-scope="scope">
                    <div class="meta-cell">
                      <div class="meta-cell-name">{{ scope.row.CreateBy || '—' }}</div>
                      <div class="meta-cell-time">{{ formatDateTimeCell(scope.row.CreateTime) }}</div>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column label="更新" width="168" align="center">
                  <template slot-scope="scope">
                    <div class="meta-cell">
                      <div class="meta-cell-name">{{ scope.row.ModifyBy || '—' }}</div>
                      <div class="meta-cell-time">{{ formatDateTimeCell(scope.row.UpdateTime) }}</div>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column label="操作" width="200" align="center" fixed="right">
                  <template slot-scope="scope">
                    <div class="table-op-pair">
                      <el-button type="text" class="table-op-link" size="small" @click="handleEdit(scope.row)">编辑</el-button>
                      <el-button type="text" class="table-op-link table-op-link--danger" size="small"
                        @click="handleDelete(scope.row)">删除</el-button>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </el-tab-pane>

          <!-- 班级公约 -->
          <el-tab-pane label="班级公约" name="convention">
            <toolbar :buttonList="buttonList" @callFunction="callFunction" :searchList="searchList"></toolbar>
            <div class="table-wrapper">
              <el-table height="100%" :data="tableData" v-loading="listLoading" class="custom-elegant-table" style="width: 100%">
                <el-table-column prop="Title" label="标题" align="center"></el-table-column>
                <el-table-column prop="Content" label="内容" align="center" show-overflow-tooltip></el-table-column>
                <el-table-column prop="CreateBy" label="创建人" width="100" align="center" show-overflow-tooltip></el-table-column>
                <el-table-column prop="CreateTime" label="创建时间" width="160" align="center">
                  <template slot-scope="scope">
                    {{ formatDateTimeCell(scope.row.CreateTime) }}
                  </template>
                </el-table-column>
                <el-table-column prop="ModifyBy" label="修改人" width="100" align="center" show-overflow-tooltip></el-table-column>
                <el-table-column prop="UpdateTime" label="更新时间" width="160" align="center">
                  <template slot-scope="scope">
                    {{ formatDateTimeCell(scope.row.UpdateTime) }}
                  </template>
                </el-table-column>
                <el-table-column label="操作" width="" align="center">
                  <template slot-scope="scope">
                    <el-link type="primary" :underline="false" @click="handleEdit(scope.row)">编辑</el-link>
                    <el-divider direction="vertical"></el-divider>
                    <el-link type="danger" :underline="false" @click="handleDelete(scope.row)">删除</el-link>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </el-tab-pane>

          <!-- 班级职务 -->
          <el-tab-pane label="班级职务" name="duty">
            <toolbar :buttonList="buttonList" @callFunction="callFunction" :searchList="searchList"></toolbar>
            <div class="table-wrapper">
              <el-table height="100%" :data="tableData" v-loading="listLoading" class="custom-elegant-table" style="width: 100%">
                <el-table-column prop="DutyName" label="职务名称" align="center"></el-table-column>
                <el-table-column label="成员" align="center" min-width="200">
                  <template slot-scope="scope">
                    <div
                      v-if="scope.row.StudentDetails && scope.row.StudentDetails.length"
                      class="member-cell"
                      @click="openMemberDialog(scope.row)"
                    >
                      <div
                        v-for="student in (scope.row.StudentDetails || []).slice(0, 5)"
                        :key="student.Id"
                        class="member-cell__item"
                      >
                        <!-- OSS 私有桶：el-avatar 不能用 v-oss-src，改用原生 img。最后修改：2026-09-14 -->
                        <img
                          v-if="student.HeadPhotoImage"
                          v-oss-src="student.HeadPhotoImage"
                          class="member-avatar member-avatar--sm"
                          alt=""
                        />
                        <el-avatar size="small" v-else>{{ student.StuName ? student.StuName.substring(0, 1) : '?' }}</el-avatar>
                        <div class="member-cell__name">{{ student.StuName }}</div>
                      </div>
                      <span
                        v-if="scope.row.StudentDetails.length > 5"
                        class="member-cell__more"
                      >
                        +{{ scope.row.StudentDetails.length - 5 }} 更多...
                      </span>
                    </div>
                    <span v-else>{{ scope.row.Students || '—' }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="更新时间" width="168" align="center">
                  <template slot-scope="scope">
                    {{ formatDateTimeCell(scope.row.UpdateTime) }}
                  </template>
                </el-table-column>
                <el-table-column label="操作" width="200" align="center" fixed="right">
                  <template slot-scope="scope">
                    <div class="table-op-pair">
                      <el-button type="text" class="table-op-link" size="small" @click="handleEdit(scope.row)">编辑</el-button>
                      <el-button type="text" class="table-op-link table-op-link--danger" size="small"
                        @click="handleDelete(scope.row)">删除</el-button>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </el-tab-pane>

          <!-- 班级合照 -->
          <el-tab-pane label="班级合照" name="snapshot">
            <toolbar :buttonList="buttonList" @callFunction="callFunction" :searchList="searchList"></toolbar>
            <div class="table-wrapper">
              <el-table height="100%" :data="tableData" v-loading="listLoading" class="custom-elegant-table portrait-table portrait-table--activity" style="width: 100%"
                :header-cell-style="{ background: '#f5f7fa', color: '#606266' }">
                <el-table-column prop="Title" label="标题" min-width="140" align="left" show-overflow-tooltip></el-table-column>
                <el-table-column label="预览" width="108" align="center">
                  <template slot-scope="scope">
                    <div v-if="getActivityMediaPreview(scope.row)" class="media-thumb"
                      @click="onActivityMediaClick(scope.row)">
                      <img :src="getActivityMediaPreview(scope.row)" class="media-thumb-img" alt="" />
                      <span v-if="getActivityImagesCount(scope.row) > 1" class="media-thumb-count">
                        +{{ getActivityImagesCount(scope.row) - 1 }}
                      </span>
                    </div>
                    <span v-else class="cell-placeholder">—</span>
                  </template>
                </el-table-column>
                <el-table-column label="更新时间" width="168" align="center">
                  <template slot-scope="scope">
                    {{ formatDateTimeCell(scope.row.UpdateTime) }}
                  </template>
                </el-table-column>
                <el-table-column label="操作" width="200" align="center" fixed="right">
                  <template slot-scope="scope">
                    <div class="table-op-pair">
                      <el-button type="text" class="table-op-link" size="small" @click="handleEdit(scope.row)">编辑</el-button>
                      <el-button type="text" class="table-op-link table-op-link--danger" size="small"
                        @click="handleDelete(scope.row)">删除</el-button>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </el-tab-pane>
        </el-tabs>

        <!-- 分页 -->
        <el-col :span="24" class="toolbar">
          <el-pagination background layout="total, prev, pager, next, jumper" :total="total" :current-page="page"
            :page-size="pageSize" @current-change="handleCurrentChange" style="float: right">
          </el-pagination>
        </el-col>
      </div>

      <!-- 通用对话框 -->
      <el-dialog :title="dialogTitle" :visible.sync="dialogVisible"
        :width="activityDialogWidth" custom-class="elegant-dialog" @closed="onActivityDialogClosed">
        <el-form :model="form" :rules="rules" ref="dataForm" label-width="100px" class="dialog-form">

          <!-- 班级活动表单项 -->
          <template v-if="activeTab === 'activity'">
            <el-form-item label="分类" prop="Category">
              <el-select v-model="form.Category" placeholder="请选择分类" style="width: 100%">
                <el-option label="活动" value="活动"></el-option>
                <el-option label="环境" value="环境"></el-option>
                <el-option label="园地" value="园地"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="内容形式">
              <el-radio-group v-model="form.IsVideo" @change="onActivityVideoModeChange">
                <el-radio :label="0">图文</el-radio>
                <el-radio :label="1">视频</el-radio>
              </el-radio-group>
              <span class="form-hint-inline">视频形态需上传封面与 mp4，且不能与外链同时使用</span>
            </el-form-item>
            <el-form-item label="主题" prop="Theme">
              <el-input v-model="form.Theme" placeholder="请输入活动主题"></el-input>
            </el-form-item>
            <el-form-item label="是否外链" prop="IsExternalLink" v-if="!isActivityVideoMode">
              <el-switch v-model="form.IsExternalLink" :active-value="1" :inactive-value="0" active-text="是"
                inactive-text="否" @change="onActivityExternalLinkChange"></el-switch>
              <span class="form-hint-inline">开启后可填微信公众号文章等链接</span>
            </el-form-item>
            <el-form-item label="外链地址" prop="ExternalLink" v-if="form.IsExternalLink === 1 && !isActivityVideoMode">
              <el-input v-model="form.ExternalLink" type="textarea" :rows="2"
                placeholder="请输入完整链接，如 https://mp.weixin.qq.com/s/..."></el-input>
            </el-form-item>
            <el-form-item label="学生" prop="StudentArray">
              <el-select v-model="form.StudentArray" multiple placeholder="请选择学生" style="width: 100%" filterable>
                <el-option v-for="item in studentOptions" :key="item.Id" :label="item.Name"
                  :value="item.Name"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="活动意义" prop="ActivityMeaning">
              <el-input type="textarea" v-model="form.ActivityMeaning" :rows="3"></el-input>
            </el-form-item>
            <el-form-item label="描述" prop="ResultDescription">
              <el-input type="textarea" v-model="form.ResultDescription" :rows="3"></el-input>
            </el-form-item>
          </template>

          <!-- 班级公约表单项 -->
          <template v-if="activeTab === 'convention'">        
            <el-form-item label="标题" prop="Title">
              <el-input v-model="form.Title" placeholder="请输入标题"></el-input>
            </el-form-item>
            <el-form-item label="内容" prop="Content">
              <el-input type="textarea" v-model="form.Content" :rows="4"></el-input>
            </el-form-item>
            <el-form-item label="排序" prop="SortIndex">
              <el-input-number v-model="form.SortIndex" :min="0" controls-position="right" class="sort-index-input"></el-input-number>
            </el-form-item>
          </template>

          <!-- 班级职务表单项 -->
          <template v-if="activeTab === 'duty'">
            <el-form-item label="职务名称" prop="DutyName">
              <el-input v-model="form.DutyName" placeholder="如：班长"></el-input>
            </el-form-item>
            <el-form-item label="成员" prop="StudentArray">
              <el-select v-model="form.StudentArray" multiple placeholder="请选择学生成员" style="width: 100%" filterable>
                <el-option v-for="item in studentOptions" :key="item.Id" :label="item.Name"
                  :value="item.Id"></el-option>
              </el-select>
            </el-form-item>
          </template>

          <!-- 班级合照表单项 -->
          <template v-if="activeTab === 'snapshot'">
            <el-form-item label="标题" prop="Title">
              <el-input v-model="form.Title" placeholder="请输入标题"></el-input>
            </el-form-item>
          </template>

          <!-- 共有项：排序和选择机构 -->
          <el-form-item label="排序" prop="SortIndex" v-if="activeTab !== 'convention'">
            <el-input-number v-model="form.SortIndex" :min="0" controls-position="right" class="sort-index-input"></el-input-number>
          </el-form-item>


          <!-- 活动/环境/园地 视频：封面 + 视频 -->
          <template v-if="activeTab === 'activity' && isActivityVideoMode">
            <el-form-item label="视频素材" class="garden-video-upload-row">
              <div class="garden-upload-group">
                <div class="garden-upload-card">
                  <div class="garden-upload-label">封面图</div>
                  <el-upload class="garden-uploader" action="#" :auto-upload="false"
                    :show-file-list="false" :on-change="handleCoverChange"
                    accept=".png,.jpg,.jpeg,.gif,.bmp,.webp">
                    <img v-if="deferredImageDisplay('cover', coverImageUrl)" v-oss-src="deferredImageDisplay('cover', coverImageUrl)" class="garden-upload-preview" />
                    <div v-else class="garden-upload-placeholder">
                      <i v-if="coverUploadLoading" class="el-icon-loading"></i>
                      <template v-else>
                        <i class="el-icon-picture-outline"></i>
                        <span>上传封面</span>
                      </template>
                    </div>
                  </el-upload>
                  <p class="garden-upload-tip">建议 10:6</p>
                </div>
                <div class="garden-upload-card">
                  <div class="garden-upload-label">视频 mp4</div>
                  <el-upload class="garden-uploader" action="#" accept="video/mp4,.mp4" :show-file-list="false"
                    :http-request="customActivityVideoUpload" :before-upload="beforeActivityVideoUpload">
                    <video v-if="activityVideoPreviewSrc" :src="activityVideoPreviewSrc"
                      class="garden-upload-preview garden-upload-preview--video" controls></video>
                    <div v-else class="garden-upload-placeholder">
                      <i v-if="videoUploadLoading" class="el-icon-loading"></i>
                      <template v-else>
                        <i class="el-icon-video-camera"></i>
                        <span>上传视频</span>
                      </template>
                    </div>
                  </el-upload>
                  <p class="garden-upload-tip">班牌播放用</p>
                </div>
              </div>
            </el-form-item>
          </template>

          <!-- 图片上传：活动/环境/园地图文、合照；外链模式下照片可作为封面选填 -->
          <el-form-item label="照片" prop="Images"
            v-if="(activeTab === 'activity' && !isActivityVideoMode) || activeTab === 'snapshot'"
            class="custom-form-item">
            <el-upload list-type="picture-card" action="#" :auto-upload="false"
              :file-list="fileList"
              :on-change="(file, list) => { deferredPictureCardChange(file, list, 'fileList'); updateImagesPath() }"
              :on-remove="(file, list) => { deferredPictureCardRemove(file, list, 'fileList'); updateImagesPath() }"
              :on-preview="handlePictureCardPreview" class="stable-uploader">
              <i class="el-icon-plus"></i>
            </el-upload>
            <el-dialog :visible.sync="previewVisible" append-to-body>
              <img width="100%" :src="previewImageUrl" alt="">
            </el-dialog>
          </el-form-item>

        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取消</el-button>
          <el-button type="primary" :loading="submitLoading" @click="submitForm">确认提交</el-button>
        </div>
      </el-dialog>

      <!-- 职务成员列表 -->
      <el-dialog
        :title="memberDialogTitle"
        :visible.sync="memberDialogVisible"
        width="520px"
        append-to-body
        :close-on-click-modal="true"
        @closed="memberDialogList = []"
      >
        <div class="member-dialog-grid">
          <div v-for="student in memberDialogList" :key="student.Id" class="member-dialog-item">
            <img
              v-if="student.HeadPhotoImage"
              v-oss-src="student.HeadPhotoImage"
              class="member-avatar member-avatar--md"
              alt=""
            />
            <el-avatar size="medium" v-else>{{ student.StuName ? student.StuName.substring(0, 1) : '?' }}</el-avatar>
            <div class="member-dialog-name" :title="student.StuName">{{ student.StuName }}</div>
          </div>
        </div>
        <div slot="footer" class="dialog-footer">
          <span class="member-dialog-count">共 {{ memberDialogList.length }} 人</span>
          <el-button type="primary" @click="memberDialogVisible = false">关 闭</el-button>
        </div>
      </el-dialog>

      <!-- 视频上传进度 -->
      <el-dialog
        title="视频上传中"
        :visible.sync="videoUploading"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :show-close="false"
        width="400px"
        append-to-body
      >
        <el-progress :percentage="videoUploadProgress" :stroke-width="16"></el-progress>
        <div style="text-align:center;margin-top:12px;color:#909399;font-size:13px;">请勿关闭或切换页面</div>
      </el-dialog>

      <el-dialog :visible.sync="videoDialogVisible" width="60%" top="5vh" append-to-body
        :close-on-click-modal="true" center @close="currentVideoUrl = ''">
        <video v-if="currentVideoUrl" :src="currentVideoUrl" controls autoplay
          style="width:100%;height:60vh;background:#000"></video>
      </el-dialog>

      <!-- 多图预览画廊 -->
      <el-dialog :visible.sync="galleryVisible" width="700px" top="5vh" append-to-body
        :close-on-click-modal="true" @close="galleryImages = []">
        <el-carousel height="460px" :autoplay="false" indicator-position="outside" arrow="always">
          <el-carousel-item v-for="(imgUrl, idx) in galleryImages" :key="idx">
            <div class="gallery-item">
              <img :src="imgUrl" class="gallery-img" alt="" />
            </div>
          </el-carousel-item>
        </el-carousel>
        <div class="gallery-counter">{{ galleryImages.length }} 张图片</div>
      </el-dialog>
    </section>
  </section>
</template>

<script>
import DepartmentPane from '../../../components/DepartmentPane'
import Toolbar from '../../../components/Toolbar'
import util from '../../../../util/date'
import { getButtonList } from '../../../promissionRouter'
import { BaseApiUrl } from '../../../api/base';
import { getTeachingDepartmentTree } from '../../../api/modules/department';
import { getClassActivityList, saveClassActivity, removeClassActivity, getClassConventionList, saveClassConvention, removeClassConvention, getClassDutyList, saveClassDuty, removeClassDuty, getClassSnapshotList, saveClassSnapshot, removeClassSnapshot } from '../../../api/modules/big-screen';
import { GetStudentSelectListByClassId } from '../../../api/modules/personnel';
import {
  attachLocalVideoFile,
  revokeLocalVideoPreview,
  ensureVideoUploaded,
  beginVideoUploadProgress,
  endVideoUploadProgress,
  createVideoUploadProgressHandlers,
} from '../../../utils/ossVideoUpload'
import { resolveMediaUrl, resolvePlayableMediaUrl, applyPlayableMediaUrl, parseMediaFilesList } from '../../../utils/mediaUrl'

export default {
  name: 'ClassPortraitManage',
  components: { Toolbar, DepartmentPane },
  computed: {
    /** 活动 Tab 且为视频形态（活动/环境/园地均可） */
    isActivityVideoMode() {
      return this.activeTab === 'activity' && Number(this.form.IsVideo) === 1
    },
    /** 活动 Tab 弹窗固定 720px，图文/视频切换时不改宽度 */
    activityDialogWidth() {
      return this.activeTab === 'activity' ? '720px' : '600px'
    },
    /** 视频预览：待提交用 blob，已保存用 OSS/服务器地址 */
    activityVideoPreviewSrc() {
      if (this.pendingVideoPreviewUrl) return this.pendingVideoPreviewUrl
      return this.activityVideoPlaySrc || this.resolveMediaUrl(this.activityVideoUrl)
    }
  },
  data() {
    return {
      BaseApiUrl: BaseApiUrl,
      activeTab: 'activity',
      DepartmentId: 0,
      currentDepartmentName: '',
      buttonList: [],
      searchList: [],
      filters: {},
      listLoading: false,
      total: 0,
      page: 1,
      pageSize: 10,
      tableData: [],
      dialogVisible: false,
      dialogTitle: '',
      submitLoading: false,
      studentOptions: [],
      uploadUrl: BaseApiUrl + '/images/Upload/Pic',
      fileList: [],
      previewVisible: false,
      previewImageUrl: '',
      coverImageUrl: '',
      activityVideoUrl: '',
      activityVideoPlaySrc: '',
      coverUploadLoading: false,
      videoUploadLoading: false,
      /** 待提交时再上传的视频文件 */
      pendingVideoFile: null,
      pendingVideoPreviewUrl: '',
      videoUploading: false,
      videoUploadProgress: 0,
      videoDialogVisible: false,
      currentVideoUrl: '',
      galleryVisible: false,
      galleryImages: [],
      memberDialogVisible: false,
      memberDialogTitle: '职务成员',
      memberDialogList: [],
      form: {
        Id: 0,
        DepartmentId: 0,
        SortIndex: 0,
        Category: '活动',
        Theme: '',
        Students: '',
        StudentArray: [],
        ActivityMeaning: '',
        ResultDescription: '',
        Title: '',
        Content: '',
        DutyName: '',
        Images: '',
        IsExternalLink: 0,
        ExternalLink: '',
        IsVideo: 0,
        CoverFile: '',
        VideoFile: ''
      },
      rules: {
        Theme: [{ required: true, message: '请输入主题', trigger: 'blur' }],
        Title: [{ required: true, message: '请输入标题', trigger: 'blur' }],
        DutyName: [{ required: true, message: '请输入职务名称', trigger: 'blur' }]
      }
    }
  },
  mounted() {
    let routers = window.localStorage.router ? JSON.parse(window.localStorage.router) : [];
    this.buttonList = getButtonList(this.$route.path, routers);
  },
  methods: {
    resolveMediaUrl,
    /** 仅本地暂存，确认提交时再上传 */
    customActivityVideoUpload(req) {
      const { file, onSuccess, onError } = req
      if (!this.DepartmentId) {
        this.$message.warning('请先选择部门')
        onError(new Error('未选择部门'))
        return
      }
      this.revokePendingVideoLocal()
      const local = attachLocalVideoFile(file)
      this.pendingVideoFile = local.pendingVideoFile
      this.pendingVideoPreviewUrl = local.pendingVideoPreviewUrl
      this.videoUploadLoading = false
      onSuccess({ success: true, response: '' })
    },
    revokePendingVideoLocal() {
      revokeLocalVideoPreview(this.pendingVideoPreviewUrl)
      this.pendingVideoFile = null
      this.pendingVideoPreviewUrl = ''
    },
    onActivityDialogClosed() {
      this.revokePendingVideoLocal()
      this.activityVideoPlaySrc = ''
    },
    formatDateTimeCell(val) {
      if (!val) return ''
      return util.formatDate.format(new Date(val), 'yyyy-MM-dd hh:mm:ss')
    },
    /** 点击成员区域，弹窗展示完整成员列表 */
    openMemberDialog(row) {
      const list = (row && row.StudentDetails) || []
      if (!list.length) return
      const dutyName = (row.DutyName || '职务').trim()
      this.openStudentListDialog(`${dutyName} - 成员`, list)
    },
    /** 班级活动/环境/园地：解析涉及学生姓名 */
    getActivityStudentNames(row) {
      if (!row || !row.Students) return []
      return String(row.Students).split(',').map(s => s.trim()).filter(Boolean)
    },
    formatActivityStudentsPreview(row) {
      const names = this.getActivityStudentNames(row)
      if (!names.length) return ''
      const preview = names.slice(0, 4).join('、')
      return names.length > 4 ? `${preview}…` : preview
    },
    /** 点击涉及学生，弹窗展示完整名单 */
    openActivityStudentDialog(row) {
      const names = this.getActivityStudentNames(row)
      if (!names.length) return
      const theme = (row.Theme || '未命名').trim()
      const category = row.Category ? `【${row.Category}】` : ''
      const nameToOption = {}
      ;(this.studentOptions || []).forEach(item => {
        if (item && item.Name) nameToOption[item.Name] = item
      })
      const list = names.map((name, index) => {
        const matched = nameToOption[name]
        return {
          Id: matched ? matched.Id : `activity_${row.Id}_${index}`,
          StuName: name,
          HeadPhotoImage: matched && matched.HeadPhotoImage ? matched.HeadPhotoImage : ''
        }
      })
      this.openStudentListDialog(`${category}${theme} - 涉及学生`, list)
    },
    openStudentListDialog(title, list) {
      if (!list || !list.length) return
      this.memberDialogTitle = title
      this.memberDialogList = list
      this.memberDialogVisible = true
    },
    /** 班级画像活动三类分类名（列表标签用） */
    isPortraitActivityCategory(cat) {
      return cat === '活动' || cat === '环境' || cat === '园地'
    },
    handleTabClick() {
      this.page = 1;
      this.getList();
    },
    /** 关闭外链时清空链接，避免列表仍显示旧地址 */
    onActivityExternalLinkChange(val) {
      if (val !== 1) {
        this.form.ExternalLink = '';
      }
    },
    onActivityVideoModeChange(val) {
      if (Number(val) === 1) {
        this.$set(this.form, 'IsExternalLink', 0);
        this.$set(this.form, 'ExternalLink', '');
        this.fileList = [];
        this.$set(this.form, 'Images', '');
      } else {
        this.clearActivityVideoAssets();
      }
    },
    clearActivityVideoAssets() {
      this.revokePendingVideoLocal();
      this.deferredImageRevoke('cover');
      this.coverImageUrl = '';
      this.activityVideoUrl = '';
      this.activityVideoPlaySrc = '';
      this.$set(this.form, 'CoverFile', '');
      this.$set(this.form, 'VideoFile', '');
    },
    resetActivityMediaState() {
      this.revokePendingVideoLocal();
      this.deferredImageRevoke('cover');
      this.fileList = [];
      this.coverImageUrl = '';
      this.activityVideoUrl = '';
      this.coverUploadLoading = false;
      this.videoUploadLoading = false;
    },
    async refreshActivityVideoPlaySrc() {
      if (this.pendingVideoPreviewUrl) {
        this.activityVideoPlaySrc = ''
        return
      }
      const raw = (this.activityVideoUrl || this.form.VideoFile || '').trim()
      const schoolId = this.DepartmentId || this.form.DepartmentId
      await applyPlayableMediaUrl(this, 'activityVideoPlaySrc', raw, schoolId)
    },
    async openVideoPreview(videoPath) {
      if (!videoPath) return
      const schoolId = this.DepartmentId || this.form.DepartmentId
      try {
        this.currentVideoUrl = await resolvePlayableMediaUrl(videoPath, schoolId)
      } catch (e) {
        this.$message.error((e && e.message) || '无法播放视频')
        return
      }
      this.videoDialogVisible = true
    },
    isActivityVideoRow(row) {
      return row && Number(row.IsVideo) === 1 && !!row.VideoFile
    },
    /** 解析 Images 字符串为相对路径数组 */
    parseImagesUrls(images) {
      return parseMediaFilesList(images);
    },
    getActivityMediaPreview(row) {
      if (!row) return '';
      if (Number(row.IsVideo) === 1 && row.CoverFile) {
        return this.$resolveImageSrc(row.CoverFile);
      }
      if (row.Images) {
        const first = this.parseImagesUrls(row.Images)[0];
        if (first) return this.$resolveImageSrc(first);
      }
      return '';
    },
    getActivityImagesCount(row) {
      if (!row || !row.Images) return 0;
      return this.parseImagesUrls(row.Images).length;
    },
    onActivityMediaClick(row) {
      if (this.isActivityVideoRow(row)) {
        this.openVideoPreview(row.VideoFile);
      } else if (row && row.Images) {
        const imgs = this.parseImagesUrls(row.Images);
        if (imgs.length > 1) {
          this.galleryImages = imgs.map(url => this.$resolveImageSrc(url));
          this.galleryVisible = true;
        } else if (imgs.length === 1) {
          this.previewImageUrl = this.$resolveImageSrc(imgs[0]);
          this.previewVisible = true;
        }
      }
    },
    handleCoverChange(file) {
      this.deferredImageChange('cover', file, { foo: 'ClassPortrait', savedUrl: this.coverImageUrl })
    },
    beforeActivityVideoUpload(file) {
      const isMp4 = file.type === 'video/mp4' || (file.name && file.name.toLowerCase().endsWith('.mp4'));
      if (!isMp4) {
        this.$message.error('视频仅支持 mp4 格式');
        return false;
      }
      const isLt100M = file.size / 1024 / 1024 < 100
      if (!isLt100M) {
        this.$message.error('上传视频大小不能超过 100MB!')
        return false
      }
      return true;
    },
    treeNodeClick(data) {
      this.DepartmentId = data.value;
      this.currentDepartmentName = data.label;
      this.page = 1;
      this.getList();
      this.getStudentList();
    },
    callFunction(item) {
      if (typeof item.search == 'object') {
        this.filters = item.search;
      } else {
        this.filters = { key: item.search };
      }
      this[item.Func].apply(this, item);
    },

    handleQuery() {
      this.page = 1;
      this.getList();
    },

    handleCurrentChange(val) {
      this.page = val;
      this.getList();
    },
    getList() {
      if (this.DepartmentId == 0) {
        this.$message.warning('请先选择左侧的班级/部门！');
        return;
      }
      
      this.listLoading = true;
      let para = {
        page: this.page,
        pageSize: this.pageSize,
        departmentId: this.DepartmentId,
        key: this.filters.key || ''
      };

      if (this.activeTab === 'activity') {
        // 固定查班级阵地，避免左侧选到学校节点时被后端推断为校级(scope=1)
        para.portraitScope = 0;
      }

      let apiFunc = null;
      switch (this.activeTab) {
        case 'activity': apiFunc = getClassActivityList; break;
        case 'convention': apiFunc = getClassConventionList; break;
        case 'duty': apiFunc = getClassDutyList; break;
        case 'snapshot': apiFunc = getClassSnapshotList; break;
      }

      apiFunc(para).then(res => {
        if (res.data.success) {
          this.total = res.data.response.dataCount;
          this.tableData = res.data.response.data;
        } else {
          this.$message.error(res.data.msg);
        }
        this.listLoading = false;
      }).catch(() => { this.listLoading = false; });
    },
    handleAdd() {
      const tabNames = {
        activity: '班级活动/环境',
        convention: '班级公约',
        duty: '班级职务',
        snapshot: '班级合照'
      };
      this.dialogTitle = '新增' + tabNames[this.activeTab];
      this.form = {
        Id: 0,
        DepartmentId: this.DepartmentId,
        SortIndex: 0,
        Category: '活动',
        Theme: '',
        Students: '',
        StudentArray: [],
        ActivityMeaning: '',
        ResultDescription: '',
        Title: '',
        Content: '',
        DutyName: '',
        Images: '',
        IsExternalLink: 0,
        ExternalLink: '',
        IsVideo: 0,
        CoverFile: '',
        VideoFile: ''
      };
      this.resetActivityMediaState();
      this.dialogVisible = true;
    },
    async handleEdit(row) {
      const tabNames = {
        activity: '班级活动/环境',
        convention: '班级公约',
        duty: '班级职务',
        snapshot: '班级合照'
      };
      this.dialogTitle = '编辑' + tabNames[this.activeTab];

      this.form = Object.assign({}, row);
      if (this.activeTab === 'convention' && (this.form.SortIndex === undefined || this.form.SortIndex === null)) {
        this.$set(this.form, 'SortIndex', 0);
      }
      if (this.activeTab === 'activity') {
        if (this.form.IsExternalLink === undefined || this.form.IsExternalLink === null) {
          this.$set(this.form, 'IsExternalLink', 0);
        } else {
          this.$set(this.form, 'IsExternalLink', Number(this.form.IsExternalLink) === 1 ? 1 : 0);
        }
        if (Number(this.form.IsExternalLink) !== 1) {
          this.$set(this.form, 'ExternalLink', '');
        }
        this.$set(this.form, 'IsVideo', Number(this.form.IsVideo) === 1 ? 1 : 0);
        this.coverImageUrl = this.form.CoverFile || '';
        this.deferredImageInit('cover', this.coverImageUrl);
        this.activityVideoUrl = this.form.VideoFile || '';
        this.revokePendingVideoLocal();
      }

      if (row.Students) {
        if (this.activeTab === 'duty' || this.activeTab === 'activity') {
          // 如果存的是数字 ID（职务），则转为数字数组；否则保持字符串数组（活动）
          // 后端 Snowflake ID 序列化为 string 返回，前端不能转为 Number，否则会丢失精度导致 el-select 无法匹配
          const arr = row.Students.split(',');
          this.$set(this.form, 'StudentArray', arr);
        } else {
          this.$set(this.form, 'StudentArray', row.Students.split(','));
        }
      } else {
        this.$set(this.form, 'StudentArray', []);
      }

      // 处理多图回显（图文形态；视频形态不用 Images）；OSS 私有桶需预签
      this.fileList = [];
      if (this.activeTab === 'activity' && Number(this.form.IsVideo) === 1) {
        this.fileList = [];
      } else if (row.Images) {
        const imgs = this.parseImagesUrls(row.Images);
        this.fileList = await this.deferredPictureCardFromMedia(imgs);
      }

      this.$set(this.form, 'Dids', []);

      this.getStudentList();
      this.dialogVisible = true;
      if (this.activeTab === 'activity' && this.isActivityVideoMode) {
        this.$nextTick(() => this.refreshActivityVideoPlaySrc())
      }
    },
    handleDelete(row) {
      this.$confirm('确认删除该记录吗？', '提示', { type: 'warning' }).then(() => {
        let deleteFunc = null;
        switch (this.activeTab) {
          case 'activity': deleteFunc = removeClassActivity; break;
          case 'convention': deleteFunc = removeClassConvention; break;
          case 'duty': deleteFunc = removeClassDuty; break;
          case 'snapshot': deleteFunc = removeClassSnapshot; break;
        }
        deleteFunc({ id: row.Id }).then(res => {
          if (res.data.success) {
            this.$message.success('删除成功');
            this.getList();
          } else {
            this.$message.error(res.data.msg);
          }
        });
      });
    },
    getStudentList() {
      if (this.DepartmentId <= 0) return;
      GetStudentSelectListByClassId({ departmentId: this.DepartmentId }).then(res => {
        if (res.data.success) {
          this.studentOptions = res.data.response || [];
        }
      });
    },
    submitForm() {
      this.$refs.dataForm.validate(async valid => {
        if (valid) {
          if (this.activeTab === 'activity' && this.form.IsExternalLink === 1 && !this.isActivityVideoMode) {
            const link = (this.form.ExternalLink || '').trim();
            if (!link) {
              this.$message.warning('开启外链时请填写完整链接地址');
              return;
            }
          }
          if (this.isActivityVideoMode) {
            const cover = this.deferredImageDisplay('cover', this.form.CoverFile || this.coverImageUrl);
            const hasVideo = this.pendingVideoFile
              || (this.form.VideoFile || this.activityVideoUrl || '').trim();
            if (!cover) {
              this.$message.warning('请上传视频封面');
              return;
            }
            if (!hasVideo) {
              this.$message.warning('请选择视频文件');
              return;
            }
          }
          this.submitLoading = true;
          if (this.isActivityVideoMode && this.pendingVideoFile) {
            beginVideoUploadProgress(this);
            try {
              const videoUrl = await ensureVideoUploaded(
                this.DepartmentId,
                this.pendingVideoFile,
                this.form.VideoFile || this.activityVideoUrl,
                'ClassPortrait',
                createVideoUploadProgressHandlers(this)
              );
              this.activityVideoUrl = videoUrl;
              this.$set(this.form, 'VideoFile', videoUrl);
              this.revokePendingVideoLocal();
              await this.refreshActivityVideoPlaySrc();
            } catch (e) {
              this.submitLoading = false;
              endVideoUploadProgress(this);
              this.$message.error((e && e.message) || '视频上传失败');
              return;
            } finally {
              endVideoUploadProgress(this);
            }
          }
          let pd = Object.assign({}, this.form);
          pd.DepartmentId = this.DepartmentId;
          if ((this.activeTab === 'activity' && !this.isActivityVideoMode) || this.activeTab === 'snapshot') {
            const imageUrls = await this.deferredPictureCardEnsure(this.fileList, 'ClassPortrait')
            pd.Images = imageUrls.join(',')
          }
          if (this.activeTab === 'activity') {
            pd.IsExternalLink = Number(pd.IsExternalLink) === 1 ? 1 : 0;
            if (pd.IsExternalLink !== 1) {
              pd.ExternalLink = '';
            } else {
              pd.ExternalLink = (pd.ExternalLink || '').trim();
            }
            if (Number(pd.IsVideo) === 1) {
              pd.IsVideo = 1;
              pd.CoverFile = await this.deferredImageEnsure('cover', { foo: 'ClassPortrait', currentUrl: pd.CoverFile || this.coverImageUrl });
              pd.VideoFile = (pd.VideoFile || this.activityVideoUrl || '').trim();
              pd.Images = '';
              pd.IsExternalLink = 0;
              pd.ExternalLink = '';
            } else {
              pd.IsVideo = 0;
              pd.CoverFile = '';
              pd.VideoFile = '';
            }
          }
          if (pd.StudentArray && pd.StudentArray.length > 0) {
            pd.Students = pd.StudentArray.join(',');
          } else if (this.activeTab === 'activity' || this.activeTab === 'duty') {
            pd.Students = '';
          }

          let saveFunc = null;
          switch (this.activeTab) {
            case 'activity': saveFunc = saveClassActivity; break;
            case 'convention': saveFunc = saveClassConvention; break;
            case 'duty': saveFunc = saveClassDuty; break;
            case 'snapshot': saveFunc = saveClassSnapshot; break;
          }

          saveFunc(pd).then(res => {
            this.submitLoading = false;
            if (res.data.success) {
              this.$message.success('保存成功');
              this.dialogVisible = false;
              this.getList();
            } else {
              this.$message.error(res.data.msg);
            }
          }).catch(() => { this.submitLoading = false; });
        }
      });
    },
    beforeUpload(file) {
      const isImg = file.type === 'image/jpeg' || file.type === 'image/png';
      if (!isImg) this.$message.error('上传图片只能是 JPG/PNG 格式!');
      return isImg;
    },
    handleUploadSuccess(res, file, fileList) {
      if (res.success) {
        // 更新 fileList 中的文件对象，确保 response 字段是相对路径
        const updatedFileList = fileList.map(f => {
          if (f.uid === file.uid) { // 找到当前上传成功的文件
            return { ...f, response: res.response, url: this.$resolveImageSrc(res.response) };
          }
          return f;
        });
        this.fileList = updatedFileList;
        this.updateImagesPath();
      } else {
        this.$message.error(res.msg);
        // 上传失败从列表中移除该文件
        const index = fileList.indexOf(file);
        if (index > -1) fileList.splice(index, 1);
        this.fileList = fileList;
      }
    },
    handleRemove(file, fileList) {
      this.fileList = fileList;
      this.updateImagesPath();
    },
    handlePictureCardPreview(file) {
      this.previewImageUrl = file.url;
      this.previewVisible = true;
    },
    updateImagesPath() {
      const paths = this.fileList.map(file => this.deferredPictureCardItemPath(file)).filter(Boolean)
      this.$set(this.form, 'Images', paths.join(','));
    },
  }
}
</script>

<style scoped>
.class-portrait-tabs {
  margin-top: 10px;
  flex: 1 1 auto;
  min-height: 0;
  height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.class-portrait-tabs >>> .el-tabs {
  flex: 1 1 auto;
  min-height: 0;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.class-portrait-tabs >>> .el-tabs__content {
  flex: 1 1 auto;
  min-height: 0;
  overflow: hidden;
}

.class-portrait-tabs >>> .el-tab-pane {
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.table-wrapper {
  margin-top: 15px;
  flex: 1 1 auto;
  min-height: 0;
  height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.table-wrapper > .el-table {
  width: 100%;
  height: 100%;
}

/* 稳定上传组件样式，防止跳动 */
.stable-uploader /deep/ .el-upload-list--picture-card {
  display: flex !important;
  flex-wrap: wrap;
  align-items: center;
  margin-top: -5px;
}

.stable-uploader /deep/ .el-upload-list--picture-card .el-upload-list__item {
  transition: none !important;
  width: 100px !important;
  height: 100px !important;
  line-height: normal !important;
  margin: 5px 10px 5px 0 !important;
  display: block;
}

.stable-uploader /deep/ .el-upload--picture-card {
  width: 100px !important;
  height: 100px !important;
  line-height: 100px !important;
  margin: 5px 0 5px 0 !important;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* 彻底禁用内置列表动画 */
.stable-uploader /deep/ .el-list-enter-active,
.stable-uploader /deep/ .el-list-leave-active {
  transition: none !important;
}

.stable-uploader /deep/ .el-list-enter,
.stable-uploader /deep/ .el-list-leave-active {
  opacity: 1 !important;
  transform: none !important;
}

/* 强制 label 与内容垂直对齐 */
.custom-form-item /deep/ .el-form-item__label {
  line-height: 100px !important;
  /* 匹配图片高度使文字居中 */
}

.custom-form-item /deep/ .el-form-item__content {
  line-height: normal !important;
  display: flex;
  align-items: center;
}

.dialog-form {
  padding: 10px 10px;
}

/* 排序号仅占必要宽度，避免整行拉满 */
.sort-index-input {
  width: 140px;
}

.form-hint-inline {
  margin-left: 12px;
  color: #909399;
  font-size: 12px;
}

.avatar-uploader /deep/ .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 100px;
  line-height: 100px;
  text-align: center;
  display: block;
}

.garden-video-cover {
  width: 178px;
  height: 100px;
  object-fit: cover;
  display: block;
}

/* 活动列表表格 */
.portrait-table--activity /deep/ .el-table__body td {
  padding: 10px 0;
}

.portrait-table /deep/ .cell {
  line-height: 1.4;
}

.category-cell {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
}

.category-name {
  font-weight: 500;
  color: #303133;
}

.theme-text {
  color: #303133;
}

.theme-link-tag {
  margin-left: 6px;
  vertical-align: middle;
  cursor: help;
}

.cell-placeholder {
  color: #c0c4cc;
}

.meta-cell {
  text-align: center;
  line-height: 1.45;
}

.meta-cell-name {
  color: #303133;
  font-size: 13px;
}

.meta-cell-time {
  color: #909399;
  font-size: 12px;
  white-space: nowrap;
}

.media-thumb {
  position: relative;
  width: 88px;
  height: 52px;
  margin: 0 auto;
  border-radius: 6px;
  overflow: hidden;
  cursor: pointer;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.12);
  transition: transform 0.15s ease, box-shadow 0.15s ease;
}

.media-thumb:hover {
  transform: translateY(-1px);
  box-shadow: 0 3px 8px rgba(0, 0, 0, 0.16);
}

.media-thumb-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.media-thumb-play {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.35);
  color: #fff;
  font-size: 22px;
}

.media-thumb-count {
  position: absolute;
  bottom: 3px;
  right: 4px;
  background: rgba(0, 0, 0, 0.55);
  color: #fff;
  font-size: 11px;
  padding: 1px 5px;
  border-radius: 8px;
  line-height: 1.5;
  pointer-events: none;
}

.gallery-item {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  background: #1a1a1a;
}

.gallery-img {
  max-width: 100%;
  max-height: 460px;
  object-fit: contain;
  display: block;
}

.gallery-counter {
  text-align: center;
  color: #909399;
  font-size: 13px;
  margin-top: 8px;
}

/* 园地视频上传：并排卡片 */
.garden-upload-group {
  display: flex;
  gap: 20px;
  flex-wrap: wrap;
}

.garden-upload-card {
  flex: 0 0 auto;
}

.garden-upload-label {
  font-size: 13px;
  color: #606266;
  margin-bottom: 8px;
  font-weight: 500;
}

.garden-uploader /deep/ .el-upload {
  border: 1px dashed #dcdfe6;
  border-radius: 8px;
  cursor: pointer;
  overflow: hidden;
  background: #fafafa;
  transition: border-color 0.2s;
}

.garden-uploader /deep/ .el-upload:hover {
  border-color: var(--btn-primary, #2563eb);
}

.garden-upload-preview {
  width: 200px;
  height: 112px;
  object-fit: cover;
  display: block;
}

.garden-upload-preview--video {
  object-fit: contain;
  background: #1a1a1a;
}

.garden-upload-placeholder {
  width: 200px;
  height: 112px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #909399;
  gap: 6px;
  font-size: 13px;
}

.garden-upload-placeholder i {
  font-size: 28px;
}

.garden-upload-tip {
  margin: 6px 0 0;
  font-size: 12px;
  color: #909399;
  text-align: center;
}

.member-cell {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  gap: 4px;
  cursor: pointer;
  padding: 4px 6px;
  border-radius: 8px;
  transition: background 0.2s;
}

.member-cell:hover {
  background: #f5f7fa;
}

.member-cell--text {
  flex-direction: column;
  align-items: flex-start;
  gap: 2px;
  max-width: 100%;
}

.member-cell__text-preview {
  font-size: 13px;
  color: #303133;
  line-height: 1.4;
  text-align: left;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  max-width: 100%;
}

.member-cell--text .member-cell__more {
  margin-left: 0;
  font-size: 12px;
}

.member-cell__item {
  margin: 2px;
  text-align: center;
  width: 48px;
}

.member-avatar {
  display: block;
  margin: 0 auto;
  object-fit: cover;
  border-radius: 50%;
  background: #f5f7fa;
}

.member-avatar--sm {
  width: 28px;
  height: 28px;
}

.member-avatar--md {
  width: 36px;
  height: 36px;
}

.member-cell__name {
  font-size: 12px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.member-cell__more {
  margin-left: 4px;
  font-size: 12px;
  color: var(--btn-primary, #2563eb);
  white-space: nowrap;
}

.member-dialog-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 16px 12px;
  max-height: 360px;
  overflow-y: auto;
  padding: 4px 2px;
}

.member-dialog-item {
  width: 72px;
  text-align: center;
}

.member-dialog-name {
  margin-top: 6px;
  font-size: 13px;
  color: #303133;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.member-dialog-count {
  float: left;
  line-height: 32px;
  font-size: 13px;
  color: #909399;
}
</style>
